import styled from 'styled-components';

const CreateSurveyWrapper = styled.div`
  .side-bar-content {
    background-color: rgba(251, 251, 251, 1) !important;
    overflow-y: auto;
    width: 300px;
    height: 100%;
    border-right: none !important;
  }

  .filter-category {
    border-radius: 0;
    border-left: 2px solid ${({ theme }) => theme.colors.background[100]};
    color: ${({ theme }) => theme.colors.dark[5]};
    &.active {
      border-left: 2px solid ${({ theme }) => theme.colors.primary[600]};
      color: ${({ theme }) => theme.colors.primary[600]};
    }
  }

  .content {
    background-color: ${({ theme }) => theme.colors.background[15]};
    border-radius: 8px;
    overflow-x: hidden;
    flex: 1;
  }

  .input-content {
    display: flex;
    align-items: center;
    textarea {
      height: 24px;
      max-height: 120px;
      resize: none;
      min-height: 20px;
      min-width: 100%;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: ${({ theme }) => theme.colors.dark[100]};
      background-color: inherit;
      border: none;
      padding: 0;
    }
  }

  .range-from {
    width: 80px;
  }
  .range {
    width: 96px;
    .error-message {
      display: none;
    }
  }
  .answer-input {
    flex: 1;
  }
  .question-type {
    width: 176px;
  }
`;

export default CreateSurveyWrapper;
